import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isValidObject, catchError } from 'corp-front-vue-commons/src/utils/functions'

const XLSXInput = {
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    companyId () {
      const routeParamId = this.$route.params && this.$route.params.id
        ? this.$route.params.id
        : null
      const companyId = this.selectedCompany && this.selectedCompany.id
        ? this.selectedCompany.id
        : null

      return routeParamId || companyId
    },

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      currentStatus: STATUS_SUCCESS
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    handleChange () {
      this.$emit('change')
    },

    isValidObject (val) {
      return isValidObject(val)
    },

    async uploadCostCenterFile (file) {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const formData = new FormData()
        formData.append('costcenterupload', file)
        const { data: res } = await this.$apiService.bulkImportCostCenter(this.companyId, formData)

        if (!res || (res && !this.isValidObject(res.data))) {
          throw new Error()
        }

        this.renderPayload(res.data)
        this.currentStatus = STATUS_SUCCESS
      } catch (error) {
        this.currentStatus = STATUS_FAILED

        this.showAlert({
          type: 'error',
          message: this.$t('Views.BulkImportPage.uploadBox.status.error')
        })

        catchError(error)
      }
    },

    async uploadEmployeeFile (file) {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const formData = new FormData()
        formData.append('employeeupload', file)
        const { data: res } = await this.$apiService.employee.bulkImport(
          this.companyId,
          formData,
          this.shouldSendWelcomeEmail
        )

        if (!res || (res && !this.isValidObject(res.data))) {
          throw new Error()
        }

        this.renderPayload(res.data)
        this.currentStatus = STATUS_SUCCESS
      } catch (error) {
        this.currentStatus = STATUS_FAILED

        this.showAlert({
          type: 'error',
          message: this.$t('Views.BulkImportPage.uploadBox.status.error')
        })

        catchError(error)
      }
    },

    async uploadProjectFile (file) {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const formData = new FormData()
        formData.append('projectupload', file)
        const { data: res } = await this.$apiService.bulkImportProject(
          this.companyId,
          formData
        )

        if (!res || (res && !this.isValidObject(res.data))) {
          throw new Error()
        }

        this.renderPayload(res.data)
        this.currentStatus = STATUS_SUCCESS
      } catch (error) {
        this.currentStatus = STATUS_FAILED

        this.showAlert({
          type: 'error',
          message: this.$t('Views.BulkImportPage.uploadBox.status.error')
        })

        catchError(error)
      }
    },

    async uploadApprovePaymentFile (file) {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const formData = new FormData()
        formData.append('file', file)
        const { data: res } = await this.$apiService.updateMassiveOrder(
          this.companyId,
          formData
        )

        if (!res || !res.valid || !res.content) {
          throw new Error()
        }

        this.renderPayload(res.content)
        this.currentStatus = STATUS_SUCCESS
      } catch (error) {
        this.currentStatus = STATUS_FAILED

        this.showAlert({
          type: 'error',
          message: this.$t('Views.BulkImportPage.uploadBox.status.error')
        })

        catchError(error)
      }
    },

    async uploadIncentivesFile (file) {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const formData = new FormData()
        formData.append('file', file)
        const { data: res } = await this.$apiService.incentives.upload(formData)

        if (!res || !res.valid || !res.content) {
          throw new Error()
        }

        await this.uploadIncentivesFilePolling(res.content)
      } catch (error) {
        this.currentStatus = STATUS_FAILED

        this.showAlert({
          type: 'error',
          message: this.$t('Views.BulkImportPage.uploadBox.status.error')
        })

        catchError(error)
      }
    },

    async uploadIncentivesFilePolling (uploadId) {
      try {
        const { data: res } = await this.$apiService.incentives.uploadPulling(uploadId)

        if (res && res.data) {
          this.renderPayload({
            ...res.data,
            uploadId
          })
          this.currentStatus = STATUS_SUCCESS
        } else {
          setTimeout(() => this.uploadIncentivesFilePolling(uploadId), 3000)
        }
      } catch (error) {
        this.currentStatus = STATUS_FAILED

        this.showAlert({
          type: 'error',
          message: this.$t('Views.BulkImportPage.uploadBox.status.error')
        })

        catchError(error)
      }
    },

    async handleSuccess (file) {
      if (this.kind === 'costCenter') {
        await this.uploadCostCenterFile(file)
        return
      }

      if (this.kind === 'employee') {
        await this.uploadEmployeeFile(file)
      }

      if (this.kind === 'project') {
        await this.uploadProjectFile(file)
      }

      if (this.kind === 'incentives') {
        await this.uploadIncentivesFile(file)
      }

      if (this.kind === 'approvePayment') {
        this.uploadApprovePaymentFile(file)
      }
    },

    renderPayload (payload) {
      this.$emit('success', payload)
    },

    handleError (error) {
      console.log('handleError')
      this.$emit('error', error)
    }
  }
}

export default XLSXInput
